import "./modules/tgh-header";
import "./modules/video-modal";
import "./modules/testimonials";
import "./modules/conditions";
import "./modules/accordion";
import "./modules/plans-table";
import "./modules/google-map";
import "./modules/locations-list";



// WEBPACK FOOTER //
// ./assets/js/global.js